import axios from "axios";
import Vue from "vue";

export const state = {
  feesSMS: [],
  feesResponse: {},
  marksSMS: [],
  marksResponse: {},
  othersSMS: [],
  feesDefaultSms: [],
  othersResponse: {},
  smsBalance: {},
  smsCalc: [],
  smsCalcFees: [],
  saveStatus: false,
};

export const getters = {
  getFeesSMS: (state) => state.feesSMS,
  getFeesResponse: (state) => state.feesResponse,
  getMarksSMS: (state) => state.marksSMS,
  getMarksResponse: (state) => state.marksResponse,
  getOtherSMS: (state) => state.othersResponse,
  SaveStatus: (state) => state.saveStatus,
  getFeesDefaultSms: (state) => state.feesDefaultSms,
  getsmsBalance: (state) => state.smsBalance,
  getSmsCalc: (state) => state.smsCalc,
  getSmsCalcFees: (state) => state.smsCalcFees,
};

export const mutations = {
  SET_FEES_SMS(state, newValue) {
    state.feesSMS = newValue;
  },
  SET_FEES_RESPONSE(state, newValue) {
    state.feesResponse = newValue;
  },
  SET_MARKS_SMS(state, newValue) {
    state.marksSMS = newValue;
  },
  SET_MARKS_RESPONSE(state, newValue) {
    state.marksResponse = newValue;
  },
  SET_OTHERS_SMS(state, newValue) {
    state.othersSms = newValue;
  },
  SET_OTHERS_RESPONSE(state, newValue) {
    state.othersResponse = newValue;
  },
  SET_FEES_DEFAULT_SMS(state, newValue) {
    state.feesDefaultSms = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.saveStatus = newValue;
  },
  SET_SMS_BALANCE(state, newValue) {
    state.smsBalance = newValue;
  },
  SET_SMS_CALC(state, newValue) {
    state.smsCalc = newValue;
  },
  SET_SMS_CALC_FEES(state, newValue) {
    state.smsCalcFees = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  subscribeSMS({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("sms-subscribe", payload)
      .then((response) => {
        commit("SET_SMS_BALANCE", response.data.data);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message:
            "Successfully, please wait for admins to confirm subscription",
        };
        commit("pushNotification", message);
        dispatch("fetchSmsBalance");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchSmsBalance({ commit }) {
    axios
      .get("sms-subscribe")
      .then((response) => {
        commit("SET_SMS_BALANCE", response.data.data);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error While fetching SMS Balance",
        };
        commit("pushNotification", message);
      });
  },

  //fees SMS
  submitFeesSMS({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("bulk-sms/fees-sms", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Messages Sent Successfully",
        };
        dispatch("fetchSmsBalance");
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Sending Messages",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  feesSmsCalc({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("marks-sms/calculate", payload)
      .then((response) => {
        commit("SET_SMS_CALC_FEES", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Calculating Messages",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchFeesSMSCount({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("fees-sms/count", payload)
      .then((response) => {
        commit("SET_FEES_RESPONSE", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Counting SMS",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchFeesSMS({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("fetch/fees-sms", payload)
      .then((response) => {
        commit("SET_FEES_SMS", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Marks SMS
  examSmsCalc({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("marks-sms/calculate", payload)
      .then((response) => {
        commit("SET_SMS_CALC", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Calculating Messages",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  submitMarksSMS({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("bulk-sms/marks-sms", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Messages Sent Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Sending Messages",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchMarksSMSCount({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("marks-sms/count", payload)
      .then((response) => {
        commit("SET_MARKS_RESPONSE", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Counting SMS",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchMarksSMS({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("fetch/marks-sms", payload)
      .then((response) => {
        commit("SET_MARKS_SMS", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  editDefaultSMS({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("update/bulk-sms", payload)
      .then((response) => {
        dispatch("fetchFeesDefaultSMS");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: response.data.msg,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchFeesDefaultSMS({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("bulk-sms")
      .then((response) => {
        commit("SET_FEES_DEFAULT_SMS", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  //Other SMS
  submitOthersSMS({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("bulk-sms/others-sms", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Messages Sent Successfully",
        };
        dispatch("fetchSmsBalance");
        commit("SET_SAVE_STATUS", false);
        commit("pushNotification", message);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Sending Messages",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchOthersSMSCount({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("others-sms/count", payload)
      .then((response) => {
        commit("SET_OTHERS_RESPONSE", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Counting SMS",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchOthersSMS({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("fetch/others-sms", payload)
      .then((response) => {
        commit("SET_OTHERS_SMS", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
};
